import { render } from "./AddVideo.vue?vue&type=template&id=50885068"
import script from "./AddVideo.vue?vue&type=script&lang=js"
export * from "./AddVideo.vue?vue&type=script&lang=js"

import "./AddVideo.vue?vue&type=style&index=0&id=50885068&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__